export default __webpack_public_path__ + "static/media/eaorvs.23ae44a9.png";